import React, { useEffect, useState } from "react";
import { MessageType } from "../../constants";
import "../../modal.css";
import logo from '../../static/images/sbilife-logo.png'
import { numDifferentiation } from "../../utils";
export default function TravelPlanFeaturesPopup({ content, closeComparision, message, openModal }) {
    return (

        <div id="popup1" className={`overlay  ${openModal}`}>
            <div class="compare_plan">
                <span onClick={() => closeComparision(message.messageId)} class="close">&#x2715; Close </span>
                <div class="plans">
                    {content ? content.plans_info.map((plan) =>
                        <div class="plan_type" key={plan.plan_id}>
                            <div class="logo"><img src={plan.ImageUrl} /></div>
                            <div class="plan_name">{plan.plan_name}</div>
                            <div class="benifit">
                                <div class="cover"> Cover : <span> ₹{numDifferentiation(plan.sum_insured)}</span> </div>
                                <div class="premium"> Premium: <span> ₹{plan.final_premium.toLocaleString('en-IN')}/year </span> </div>
                            </div>
                            {plan.user_view_count ?
                                <div className="userViewsCount">
                                    {plan.user_view_count} people are viewing this plan
                                </div>
                                : null}
                        </div>
                    ) : null}


                </div>
                <div class="comparison">
                    <div class="heading">
                        Comparison summary
                        <div class="summary">{content && content.comparison_features ? content.comparison_features.length : null} key differences</div>
                    </div>
                    <div class="wrap-roller">
                        {content && content.comparison_features ? content.comparison_features.map((features) =>
                            <div class="plan-info" key={features.feature_order}>
                                <div class="cmp-heading">{features.feature_name}</div>
                                <div class="cmp-details">
                                    {features.feature_text.map((item) =>
                                        <div class="info" key={item.plan_id}>
                                            {item.crisp_value ?
                                                <>
                                                    <span>  <div dangerouslySetInnerHTML={{ __html: item.crisp_value }} /></span>
                                                    <span class="small"> <div dangerouslySetInnerHTML={{ __html: item.crisp_detail }} /> </span>

                                                    {item.best_in_comparison ?

                                                        <em class="bestBuy">Best in this comparison <i></i></em>
                                                        : null}
                                                </>
                                                : "N/A"}
                                        </div>
                                        // <div class="info">
                                        //     <span>500+ hospitals</span>
                                        // </div>
                                    )}
                                </div>
                            </div>
                        ) : null}

                    </div>
                </div>

            </div>
        </div>
    );
}
